import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/profile.svg';

export const IconProfile = createIconComponent(Icon);
